import { jsx } from 'react/jsx-runtime';
import { useRef, useCallback, useLayoutEffect } from 'react';
import classNames from 'classnames';
import { useCollapsibleText } from '../CollapsibleText.Context/index.es.js';

const CollapsibleTextContext = ({ className, children })=>{
    const { collapsed, disabled, expanded, maxLines, setCollapsed } = useCollapsibleText();
    const containerRef = useRef(null);
    const checkCollapse = useCallback(()=>{
        if (containerRef.current) {
            const node = containerRef.current;
            const lineHeight = parseInt(window.getComputedStyle(node).lineHeight);
            const maxHeight = lineHeight * maxLines;
            const shouldCollapse = node.scrollHeight > maxHeight;
            setCollapsed(shouldCollapse);
        }
    }, [
        maxLines,
        setCollapsed
    ]);
    useLayoutEffect(()=>{
        const resizeObserver = new ResizeObserver(checkCollapse);
        if (containerRef.current) {
            resizeObserver.observe(containerRef.current);
        }
        // make initial check
        checkCollapse();
        return ()=>resizeObserver.disconnect();
    }, [
        checkCollapse
    ]);
    return jsx("div", {
        ref: containerRef,
        className: classNames('cb-collapsible-text-content', {
            clamp: !expanded && !disabled && collapsed
        }, className),
        "data-testid": "collapsible-text-container",
        style: {
            '--collapsible-text-line-clamp': maxLines
        },
        children: children
    });
};

export { CollapsibleTextContext };
//# sourceMappingURL=CollapsibleText.Content.es.js.map
